import type { EntityPermission } from '../../../../../services/event/getEvent'
import type { PlayerWithPermission } from '../../../../../services/player/playerProfile'
import { resolvePlayerAdminAccess } from '../utils/resolvePlayerAdminAccess'
import { usePlayerWithPermission } from './usePlayerWithPermission'

const selectPermission = (
  response: PlayerWithPermission<unknown>
): EntityPermission | null => response.permission

/**
 * Whether the current user may open this player's admin details. Reads the
 * permission that came with GET /players/:id — no extra request. Denies while
 * the player is loading and when the response carries no permission.
 */
export const usePlayerAdminAccess = (playerId: string | undefined): boolean => {
  'use memo'

  const { data: permission } = usePlayerWithPermission<
    unknown,
    EntityPermission | null
  >(playerId, selectPermission)

  return resolvePlayerAdminAccess(permission)
}
